<template>
  <div class="my-aside">
    <div
      class="side-btn-box"
      :class="{ 'side-btn-box-unfold': !sideCollapse }"
      @click="toggleSide"
    >
      <span
        class="side-title"
        v-show="!sideCollapse"
      >{{pMenuName}}</span>
      <i
        :class="{
            'el-icon-s-unfold': sideCollapse,
            'el-icon-s-fold': !sideCollapse,
          }"
        :title="pMenuName"
      ></i>
    </div>
    <div class="menu-box">
      <el-scrollbar style="height:100%;">
        <el-menu
          :router="true"
          :collapse="sideCollapse"
          :default-openeds="defaultOpeneds"
          mode="vertical"
          class="el-menu-vertical-demo"
          :default-active="defaultActive"
          @select="selectHandler"
          :unique-opened="uniqueOpened"
          active-text-color="#4085EA"
          text-color="#1e1e1e"
        >
          <!-- 这里先将一级菜单生成，防止调用递归子菜单时多一个根div，影响样式 -->
          <template v-for="(value, index) in this.pMenuList">
            <el-submenu
              :index="
                value.Url == '#' || !value.Url ? '#' + value.ID : value.Url
              "
              @click="toLink(value.Url, value.Target)"
              v-if="hasChild(value.ID)"
              :key="value.ID"
            >
              <template slot="title">
                <i :class="value.Icon"></i>
                <span slot="title">{{ value.Name }}</span>
              </template>
              <MyMenu :pID="value.ID"></MyMenu>
            </el-submenu>
            <el-menu-item
              :index="
                value.Url == '#' || !value.Url ? '#' + value.ID : value.Url
              "
              v-else
              :key="value.ID"
              @click="toLink(value.Url, value.Target)"
            >
              <i :class="value.Icon"></i>
              <span slot="title">{{ value.Name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import MyMenu from "./Menu"; //引入子菜单组件
import { menuRouteMixin } from "../../mixins/menuRoute";
export default {
  components: {
    MyMenu,
  },
  mixins: [menuRouteMixin],
  data() {
    return {
      sideCollapse: false,
      pMenuList: [],
      defaultActive: "",
      pMenuName: "",
      uniqueOpened: false,
      defaultOpeneds: [],
    };
  },
  methods: {
    toggleSide() {
      this.sideCollapse = !this.sideCollapse;
    },
    hasChild(id) {
      let that = this;
      let tempMenuList = this.$store.state.menuData.filter(function (m) {
        return m.ParentID == id;
      });
      return tempMenuList.length > 0;
    },
    selectHandler(index, indexPath) {
      this.$store.commit("saveCurLeftMenu", index);
    },
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.pMenuList = that.$store.state.menuData.filter((item) => {
        return item.ParentID == that.$store.state.leftMenuPID; //一级菜单父id为"0"
      });
      let sMenuList = that.$store.state.menuData.filter((item) => {
        return item.ID == that.$store.state.leftMenuPID; //一级菜单父id为"0"
      });
      if (sMenuList) that.pMenuName = sMenuList[0].Name;
      that.$nextTick(() => {
        let match = window.sessionStorage.getItem("curLeftMenu");
        that.defaultActive = match;
        // if (match.indexOf("skin=black") == -1) that.setSkin(1);
        // else that.setSkin(2);
        that.defaultOpeneds = that.$store.state.defaultOpeneds;
      });
    });
  },
  watch: {
    "$store.state.leftMenuPID": function (newVal, oldVal) {
      let that = this;
      that.$nextTick(() => {
        that.pMenuList = that.$store.state.menuData.filter((item) => {
          return item.ParentID == newVal; //一级菜单父id为"0"
        });
        let sMenuList = that.$store.state.menuData.filter((item) => {
          return item.ID == newVal; //一级菜单父id为"0"
        });
        if (sMenuList) that.pMenuName = sMenuList[0].Name;
      });
    },
    "$store.state.defaultOpeneds": {
      handler(newVal, oldVal) {
        // do something
        let that = this;
        that.defaultOpeneds = that.$store.state.defaultOpeneds;

        let match = window.sessionStorage.getItem("curLeftMenu");
        that.defaultActive = match;
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-menu-vertical-demo {
  height: 100%;
  box-sizing: border-box;
  border-right: 0px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
}

.my-aside {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: solid 1px @border;
  background: #fff;
}
.side-btn-box {
  flex-shrink: 0;
  width: 60px;
  height: 30px;
  box-sizing: border-box;
  //border-right: solid 1px #e6e6e6;
  //border-bottom: 1px solid @border;
  background: #fff;
  cursor: pointer;
  display: flex;
  //justify-content: space-between;
  justify-content: center;
  align-items: center;
  transition: width 0.3s ease-in-out, background 0.3s;
  padding: 0 8px;
  .side-title {
    font-size: 18px;
    font-weight: bold;
    padding: 0 8px;
  }
}
.side-btn-box:hover {
  background: #ecf5ff;
}
.side-btn-box-unfold {
  width: 240px;
}
.side-btn-box i {
  font-size: 20px;
}

/deep/.el-menu--collapse {
  width: 60px;
  .el-submenu .el-submenu__title {
    padding-left: 20px !important;
  }
  .el-menu-item {
    padding-left: 20px !important;
    > div {
      padding-left: 20px !important;
    }
  }
}

/deep/.el-menu-item {
  height: 40px;
  line-height: 40px;
}
/deep/.el-submenu__title {
  height: 40px;
  line-height: 40px;
}
.el-submenu.is-active i {
  color: inherit;
}
.el-submenu__title {
  font-size: 16px;
}
/* 未选中时的颜色继承title颜色，分为有子菜单和没有子菜单时 */
.el-submenu__title i {
  color: inherit;
}

.el-menu-item {
  font-size: 16px !important;
}

.el-menu-item i {
  color: inherit;
}
.el-submenu.is-active i {
  color: inherit;
}
.menu-box {
  height: calc(100% - 30px);
  /deep/.el-menu-vertical-demo.el-menu
    .el-submenu.is-active
    .el-submenu__title::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: @basecolor;
  }
  .el-menu-vertical-demo > .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: @basecolor;
  }
}
/deep/ .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
